export const truncate = function truncate(text, limit = 100) {
  if (!text) return ''

  if (text.length <= limit) return text
  return `${text.slice(0, limit)}...`
}
